import React from 'react';

import { ServiceInformation } from 'common/modules/domain/plan';
import { Image, Button, Title, Description } from 'common/components';
import { Glossary, PlanDetailGL } from 'common/utils/glossary';
import { appBaseUrl } from 'common/utils/urls';

interface Props {
  /** 表示するサービス */
  service: ServiceInformation;
  /** グロッサリ */
  glossary: Glossary;
}

export const Service: React.FC<Props> = ({ glossary, service }) => {
  const [isShowDetail, setIsShowDetail] = React.useState<boolean>(false);
  const buttonImage = isShowDetail
    ? 'list_area_close.svg'
    : 'list_area_open.svg';
  const buttonStyle: React.CSSProperties = {
    backgroundImage: `url("${appBaseUrl}/st/images/common/${buttonImage}")`
  };
  return (
    <div className="service" data-test={`${service.serviceId}-Service`}>
      <div
        className="linearLayout"
        data-test={`${service.serviceId}-linerLayout`}
      >
        <Image
          type="icon"
          imageSrc={service.imageUrl}
          data-test={`${service.serviceId}-icon`}
        />
        <div className="info" data-test={`${service.serviceId}-info`}>
          <Title type="name" data-test={`${service.serviceId}-title`}>
            {service.name}
          </Title>
          <Description
            type="description"
            data-test={`${service.serviceId}-description`}
          >
            {service.description}
          </Description>
          <Button
            type="detailButton"
            style={buttonStyle}
            onClick={() => {
              setIsShowDetail(!isShowDetail);
            }}
            data-test={`${service.serviceId}-button`}
          >
            {glossary.glx(PlanDetailGL.Details)}
          </Button>
        </div>
      </div>
      {
        <Description
          type="detail"
          data-test={`${service.serviceId}-detail`}
          style={{ display: !isShowDetail ? 'none' : 'block' }}
        >
          {service.details}
        </Description>
      }
    </div>
  );
};
